// extracted by mini-css-extract-plugin
export var buttons = "IncrementButton_buttons__9vCrj";
export var lineText = "IncrementButton_lineText__pUo7s";